module.exports = __webpack_public_path__ + "media/images/athletes/1594-f141487e5d0b830732842c3fc4c919ee.png";